(() => {
  // handle clicks on accordion headers
  function adjustAccordion($accordion) {
    if (!$accordion.length) {
      return;
    }
    const accordionBody = $accordion.find(".accordion_body");
    if (!accordionBody.length) {
      console.error("Accordion body not found.");
      return;
    }
    const group = accordionBody.find(".product-group-variants");
    if (!group.length) {
      console.error("Product group variants not found.");
      return;
    }
    const height = group[0].scrollHeight;
    accordionBody.css("height", `${height}px`);
  }

  function openAccordion($accordion) {
    if (!$accordion.length) {
      return;
    }
    const accordionBody = $accordion.find(".accordion_body");
    if (!accordionBody.length) {
      console.error("Accordion body not found.");
      return;
    }
    const height = accordionBody[0].scrollHeight;
    accordionBody.css("height", `${height}px`);
    $accordion.addClass("open");
  }

  function closeAccordion($accordion) {
    if (!$accordion.length) return;
    $accordion.removeClass("open").find(".accordion_body").css("height", "0px");
  }

  (() => {
    const accordionHeaders = $(".custom_accordion .accordion_header");
    accordionHeaders.each(function () {
      $(this).on("click", function () {
        const accordion = $(this).parent();
        if (accordion.hasClass("open")) {
          closeAccordion(accordion);
        } else {
          openAccordion(accordion);
          // close other accordions
          // accordion.siblings(".custom_accordion.open").each(function () {
          //   closeAccordion($(this));
          // });
        }
      });
    });

    // initialize height
    const openedAccordion = $(".custom_accordion.open");
    openedAccordion.each(function () {
      openAccordion($(this));
    });
  })();

  // handle images
  const gateImageCache = {};

  function updateImage_gate(imgUrl) {
    const thumbnail = $(
      $(
        ".product-single__thumbnails .product-single__thumbnails-items:not(.hide) .product-single__thumbnail",
      )[1],
    );
    const thumbnailImg = thumbnail.find("img");
    thumbnail.attr("href", imgUrl);
    thumbnail.attr("data-zoom", imgUrl);
    thumbnail.data("zoom", imgUrl);
    thumbnailImg.attr("src", imgUrl);
    thumbnail.data("src", imgUrl);
    thumbnail.click();

    const mobileImgOwl = $(".product_photo_container .owl-item:nth-child(4)");
    mobileImgOwl.find(".product-single__photo").attr("data-zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo").data("zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("data-src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").data("src", imgUrl);
  }

  function loadImage_gate(gateDesignColour, callback) {
    if (gateImageCache[gateDesignColour]) {
      callback(gateImageCache[gateDesignColour]);
      return;
    }

    const baseUrl = "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/";
    const imageUrl = `${baseUrl}${gateDesignColour}.jpg`;
    const fallbackUrl = `${baseUrl}${gateDesignColour.split("-")[0]}.jpg`;

    const loadAndCache = (url) => {
      const img = new Image();
      img.onload = function () {
        gateImageCache[gateDesignColour] = url;
        callback(url);
      };
      img.onerror = function () {
        if (url !== fallbackUrl) {
          loadAndCache(fallbackUrl);
        } else {
          console.error("Failed to load image:", url);
          callback(null);
        }
      };
      img.src = url;
    };

    loadAndCache(imageUrl);
  }

  const doorImageCache = {};

  function updateImage_door(imgUrl) {
    const thumbnail = $(
      $(
        ".product-single__thumbnails .product-single__thumbnails-items:not(.hide) .product-single__thumbnail",
      )[0],
    );
    const thumbnailImg = thumbnail.find("img");
    thumbnail.attr("href", imgUrl);
    thumbnail.attr("data-zoom", imgUrl);
    thumbnail.data("zoom", imgUrl);
    thumbnailImg.attr("src", imgUrl);
    thumbnail.data("src", imgUrl);
    thumbnail.click();

    const mobileImgOwl = $(".product_photo_container .owl-item:nth-child(3)");
    mobileImgOwl.find(".product-single__photo").attr("data-zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo").data("zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("data-src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").data("src", imgUrl);
  }

  function loadImage_door(imageUrl, callback) {
    if (doorImageCache[imageUrl]) {
      callback(doorImageCache[imageUrl]);
      return;
    }
    const img = new Image();
    img.onload = function () {
      doorImageCache[imageUrl] = imageUrl;
      callback(imageUrl);
    };
    img.onerror = function () {
      console.error("Failed to load image:", imageUrl);
      callback(null);
    };
    img.src = imageUrl;
  }

  // handle selectors
  (() => {
    const productTemplate = $("#product-door-gate-8890655932643");
    if (!productTemplate.length) return;

    const selectors = productTemplate.find(".door-gate-bundle-selector");
    selectors.each(function () {
      const items = $(this).find(".item");
      items.on("click", function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");

        const selector = $(this).closest(".door-gate-bundle-selector");
        if (selector) {
          const option = selector.attr("data-option");
          switch (option) {
            case "product_type":
              handleProductTypeChange($(this));
              resetAll();
              break;

            case "door-type":
              handleDoorTypeChange($(this));
              break;

            case "door-fire_rating":
              handleDoorFireRatingChange($(this));
              break;

            case "door-size":
              handleDoorSizeChange($(this));
              break;

            case "gate-type":
              handleGateTypeChange($(this));
              break;

            case "gate-size":
              handleGateSizeChange($(this));
              updateGateDesignDisplay();
              break;

            case "gate-colours":
              handleGateColourChange($(this));
              break;

            case "locks-type":
              handleLocksTypeChange($(this));
              updateDoorLockColourDisplay();
              updateGateLockColourDisplay();
              updateSmartLockAddOnPrice();
              break;

            case "door-lock-model":
              handleDoorLockModelChange($(this));
              updateDoorLockColourDisplay();
              updateSmartLockAddOnPrice();
              break;

            case "door-lock-features":
              handleDoorLockFeaturesChange($(this));
              updateDoorLockColourDisplay();
              updateSmartLockAddOnPrice();
              break;

            case "gate-lock-model":
              handleGateLockModelChange($(this));
              updateGateLockColourDisplay();
              updateSmartLockAddOnPrice();
              break;

            case "gate-lock-features":
              handleGateLockFeaturesChange($(this));
              updateGateLockColourDisplay();
              updateSmartLockAddOnPrice();
              break;

            case "door-lock-colour":
            case "gate-lock-colour":
              handleLockColourChange($(this));
              updateSmartLockAddOnPrice();
              break;

            case "locks-warranty":
              updateLockWarrantyAddOnPrice();
              break;

            default:
              break;
          }
        }

        summarizePrices();

        adjustAccordion($(this).closest(".custom_accordion.open"));

        selector.find(".error_msg").addClass("hide");
      });
    });

    productTemplate
      .find(".door-gate-bundle-selector[data-option='door-laminate'] select")
      .on("change", function () {
        updateDoorImage();
      });

    productTemplate
      .find(".door-gate-bundle-selector[data-option='gate-design'] select")
      .on("change", function () {
        updateGateImage();
      });

    summarizePrices();

    // #region Functions
    function updatePrice() {
      var updatePrice = $("#currentSelection").attr("data-price");
      var updateCompare = $("#currentSelection").attr("data-compare");

      updatePrice = parseFloat(updatePrice.replace(/,/g, "")) * 100;
      updateCompare = parseFloat(updateCompare.replace(/,/g, "")) * 100;

      $("span#ProductPrice-product-template").text(
        theme.Currency.formatMoney(updatePrice).replace(".00", ""),
      );
      $("s#ComparePrice-product-template").text(
        theme.Currency.formatMoney(updateCompare).replace(".00", ""),
      );
    }

    function handleProductTypeChange($this) {
      const productType = $this.attr("data-product_type");

      const door = $(".custom_accordion[data-product_type='door']");
      const gate = $(".custom_accordion[data-product_type='gate']");

      door.addClass("hide");
      gate.addClass("hide");

      switch (productType) {
        case "door":
          door.removeClass("hide");
          openAccordion(door);
          closeAccordion(gate);

          // close other accordions
          door.siblings(".custom_accordion.open").each(function () {
            closeAccordion($(this));
          });

          // hide thumb disclaimer
          $(".thumb-disclaimer").addClass("hide");
          break;

        case "gate":
          gate.removeClass("hide");
          openAccordion(gate);
          closeAccordion(door);

          // close other accordions
          gate.siblings(".custom_accordion.open").each(function () {
            closeAccordion($(this));
          });

          // show thumb disclaimer
          if ($("[data-option='gate-type'] .item.active").length) {
            $(".thumb-disclaimer").removeClass("hide");
          }
          break;

        default:
          door.removeClass("hide");
          gate.removeClass("hide");
          openAccordion(door);
          closeAccordion(gate);

          // close other accordions
          door.siblings(".custom_accordion.open").each(function () {
            closeAccordion($(this));
          });

          // show thumb disclaimer
          if ($("[data-option='gate-type'] .item.active").length) {
            $(".thumb-disclaimer").removeClass("hide");
          }
          break;
      }
    }

    function handleDoorTypeChange($this) {
      const doorType = $this.attr("data-door_type");
      const fireRatingWrapper = $("[data-option='door-fire_rating']");
      const doorSizeWrapper = $("[data-option='door-size']");
      switch (doorType) {
        case "swd":
          fireRatingWrapper.addClass("hide");
          doorSizeWrapper.removeClass("hide");
          break;
        case "frd":
          fireRatingWrapper.removeClass("hide");
          doorSizeWrapper.addClass("hide");
          break;
      }
      fireRatingWrapper.find(".item").removeClass("active");
      fireRatingWrapper
        .find(".item[data-door_fire_rating='30']")
        .addClass("active");
      $("[data-option='door-size']").removeClass("hide");
      updateDoorSizeDisplay();

      const productType = $("[data-option='product_type'] .item.active").attr(
        "data-product_type",
      );
      if (productType == "bundle") {
        const selectedGateSize = $("[data-option='gate-size'] .item.active");
        if (selectedGateSize.length) {
          const gateSize = selectedGateSize
            .attr("data-gate_size")
            ?.split("-")[0];
          if (gateSize == "3ft") {
            $(
              `[data-option='door-size'] .item[data-door_size^='4ft']`,
            ).addClass("hide");
          } else if (gateSize == "4ft") {
            $(
              `[data-option='door-size'] .item[data-door_size^='3ft']`,
            ).addClass("hide");
          }
        } else {
          $(
            "[data-option='gate-type'] .item.active, [data-option='gate-size'] .item.active",
          ).removeClass("active");
          $("[data-option='gate-size'], [data-option='gate-design']").addClass(
            "hide",
          );
        }
      }
    }

    function handleDoorFireRatingChange($this) {
      $("[data-option='door-size']").removeClass("hide");
      updateDoorSizeDisplay();

      const productType = $("[data-option='product_type'] .item.active").attr(
        "data-product_type",
      );
      if (productType == "bundle") {
        $("[data-option='gate-type'] .item.active").click();
      }
    }

    function updateDoorSizeDisplay() {
      const doorType = $("[data-option='door-type'] .item.active").attr(
        "data-door_type",
      );
      const fireRating = $(
        "[data-option='door-fire_rating']:not(.hide) .item.active",
      ).attr("data-door_fire_rating");

      const doorSizeItems = $("[data-option='door-size'] .item");
      doorSizeItems.addClass("hide").removeClass("active");

      const selector = fireRating
        ? `[data-option='door-size'] .item[data-door_type='${doorType}'][data-fire_rating='${fireRating}']`
        : `[data-option='door-size'] .item[data-door_type='${doorType}']`;
      $(selector).removeClass("hide");
    }

    function handleDoorSizeChange($this) {
      updateDoorImage();

      const productType = $("[data-option='product_type'] .item.active").attr(
        "data-product_type",
      );
      if (productType == "bundle") {
        $("[data-option='gate-type'] .item.active").click();
      }
    }

    function handleGateTypeChange($this) {
      const gateType = $this.attr("data-gate_type");

      $("[data-option='gate-size']").removeClass("hide");
      $("[data-option='gate-design']").addClass("hide");

      const gateSizeItems = $("[data-option='gate-size'] .item");
      gateSizeItems.addClass("hide").removeClass("active");

      $(
        `[data-option='gate-size'] .item[data-gate_type='${gateType}']`,
      ).removeClass("hide");

      const productType = $("[data-option='product_type'] .item.active").attr(
        "data-product_type",
      );
      if (productType == "bundle") {
        const selectedDoorSize = $("[data-option='door-size'] .item.active");
        if (selectedDoorSize.length) {
          const doorSize = selectedDoorSize
            .attr("data-door_size")
            ?.split("-")[0];
          if (doorSize == "3ftx7ft") {
            $(
              `[data-option='gate-size'] .item[data-gate_type='${gateType}'][data-gate_size^='4ft-7ft']`,
            ).addClass("hide");
          } else if (doorSize == "4ftx7ft") {
            $(
              `[data-option='gate-size'] .item[data-gate_type='${gateType}'][data-gate_size^='3ft-7ft']`,
            ).addClass("hide");
          }
        } else {
          $(
            "[data-option='door-type'] .item.active, [data-option='door-fire_rating'] .item.active, [data-option='door-size'] .item.active",
          ).removeClass("active");
          $(
            "[data-option='door-fire_rating'], [data-option='door-size']",
          ).addClass("hide");
        }
      }

      $("[data-option='gate-laminate']").addClass("hide");
      if (gateType == "gate-laser-laminate-series") {
        $("[data-option='gate-laminate']").removeClass("hide");
        $("[data-option='gate-plate'] .item").removeClass("active");
        $(
          "[data-option='gate-plate'] .item[data-variant='46369809498339']",
        ).addClass("hide");
      } else {
        $(
          "[data-option='gate-plate'] .item[data-variant='46369809498339']",
        ).removeClass("hide");
      }

      if (productType == "bundle" || productType == "gate") {
        $(".thumb-disclaimer").removeClass("hide");
      }

      updateGateDesignDisplay();
    }

    function handleGateSizeChange() {
      $("[data-option='gate-design']").removeClass("hide");
    }

    function updateGateDesignDisplay() {
      const gateType = $("[data-option='gate-type'] .item.active").attr(
        "data-gate_type",
      );
      const gateSize = $(
        "[data-option='gate-size']:not(.hide) .item.active",
      ).attr("data-gate_size");

      $("[data-option='gate-design'] select").addClass("hide");
      $(
        `[data-option='gate-design'] select[data-gate_type='${gateType}'][data-gate_size='${gateSize}']`,
      )
        .removeClass("hide")
        .first()
        .trigger("change");
    }

    function handleGateColourChange($this) {
      const gateColour = $this.attr("data-gate_colour");
      const gateColourText = $this.attr("data-title");

      const wrapper = $this.closest(".door-gate-bundle-selector");
      wrapper.find(".initial-group").text(gateColourText);

      updateGateImage();
    }

    function handleLocksTypeChange($this) {
      const lockType = $this.attr("data-lock_type");
      const doorLockWrapper = $(
        ".product-selector-container[data-product='door-lock']",
      );
      const gateLockWrapper = $(
        ".product-selector-container[data-product='gate-lock']",
      );
      const doorLockTitle = doorLockWrapper.find("> .group-title");
      const gateLockTitle = gateLockWrapper.find("> .group-title");

      switch (lockType) {
        case "bundle":
          doorLockWrapper.removeClass("hide");
          gateLockWrapper.removeClass("hide");
          doorLockTitle.removeClass("hide");
          gateLockTitle.removeClass("hide");
          break;
        case "door_lock":
          doorLockWrapper.removeClass("hide");
          gateLockWrapper.addClass("hide");
          doorLockTitle.addClass("hide");
          gateLockTitle.addClass("hide");
          break;
        case "gate_lock":
          doorLockWrapper.addClass("hide");
          gateLockWrapper.removeClass("hide");
          doorLockTitle.addClass("hide");
          gateLockTitle.addClass("hide");
          break;

        default:
          doorLockWrapper.addClass("hide");
          gateLockWrapper.addClass("hide");
          doorLockTitle.addClass("hide");
          gateLockTitle.addClass("hide");
          break;
      }

      handleLocksExtendedWarranty();

      adjustAccordion($this.closest(".custom_accordion.open"));
    }

    function handleDoorLockModelChange($this) {
      $this
        .closest(".door-gate-bundle-selector")
        .find(".initial-group")
        .text($this.attr("data-title"));
      handleLocksExtendedWarranty();
    }

    function handleDoorLockFeaturesChange($this) {
      $this
        .closest(".door-gate-bundle-selector")
        .find(".initial-group")
        .text($this.attr("data-title"));
      handleLocksExtendedWarranty();
    }

    function handleGateLockModelChange($this) {
      $this
        .closest(".door-gate-bundle-selector")
        .find(".initial-group")
        .text($this.attr("data-title"));
      handleLocksExtendedWarranty();
    }

    function handleGateLockFeaturesChange($this) {
      $this
        .closest(".door-gate-bundle-selector")
        .find(".initial-group")
        .text($this.attr("data-title"));
      handleLocksExtendedWarranty();
    }

    function updateDoorLockColourDisplay() {
      const doorLockModel = $(
        `[data-option="door-lock-model"] .item.active`,
      ).attr("data-lock_model");
      const doorLockFeatures = $(
        `[data-option="door-lock-features"] .item.active`,
      ).attr("data-lock_features");

      $(`[data-option="door-lock-colour"] li`)
        .addClass("hide")
        .removeClass("active");

      const availableDoorLockColours = $(
        `[data-option="door-lock-colour"] li[data-lock_model="${doorLockModel}"][data-lock_features="${doorLockFeatures}"]`,
      );
      const firstDoorLockColour = availableDoorLockColours.first();

      availableDoorLockColours.removeClass("hide");
      firstDoorLockColour.addClass("active");

      $(`[data-option="door-lock-colour"] .initial-group`).text(
        firstDoorLockColour.attr("data-title"),
      );
    }

    function updateGateLockColourDisplay() {
      const gateLockModel = $(
        `[data-option="gate-lock-model"] .item.active`,
      ).attr("data-lock_model");
      const gateLockFeatures = $(
        `[data-option="gate-lock-features"] .item.active`,
      ).attr("data-lock_features");

      $(`[data-option="gate-lock-colour"] li`)
        .addClass("hide")
        .removeClass("active");

      const availableGateLockColours = $(
        `[data-option="gate-lock-colour"] li[data-lock_model="${gateLockModel}"][data-lock_features="${gateLockFeatures}"]`,
      );
      const firstGateLockColour = availableGateLockColours.first();

      availableGateLockColours.removeClass("hide");
      firstGateLockColour.addClass("active");

      $(`[data-option="gate-lock-colour"] .initial-group`).text(
        firstGateLockColour.attr("data-title"),
      );
    }

    function handleLockColourChange($this) {
      $this
        .closest(".door-gate-bundle-selector")
        .find(".initial-group")
        .text($this.attr("data-title"));
    }

    function handleLocksExtendedWarranty() {
      const warranty_addon = $(
        ".custom_accordion[data-product_type='locks-warranty-addon']",
      );
      const lockType = $("[data-option='locks-type'] .item.active").attr(
        "data-lock_type",
      );

      // Reset the period options + selection every time the lock(s) change.
      const periodItems = $("[data-option='locks-warranty'] .ew-period-item");
      periodItems
        .addClass("hide")
        .removeClass("active")
        .removeAttr("data-variants")
        .removeAttr("data-price");
      periodItems.find(".price").text("");
      periodItems.find(".compare-at-price").text("");
      periodItems.find(".description").empty();
      $("[data-option='locks-warranty'] .ew-none").addClass("active");
      warranty_addon.addClass("hide");

      if (!lockType) {
        updateLockWarrantyAddOnPrice();
        return;
      }

      // Build the warranty match key(s) for the currently selected lock(s).
      // EW variant models are per single lock (no combined door+gate variant),
      // so a bundle produces two keys and each period sums both prices.
      const warrantyKeys = [];
      if (lockType === "bundle" || lockType === "door_lock") {
        const model = $("[data-option='door-lock-model'] .item.active").attr(
          "data-lock_model",
        );
        const features = $(
          "[data-option='door-lock-features'] .item.active",
        ).attr("data-lock_features");
        if (model) {
          warrantyKeys.push(
            `${model}${features === "ultra" ? "-ultra" : ""}-door-lock`,
          );
        }
      }
      if (lockType === "bundle" || lockType === "gate_lock") {
        const model = $("[data-option='gate-lock-model'] .item.active").attr(
          "data-lock_model",
        );
        const features = $(
          "[data-option='gate-lock-features'] .item.active",
        ).attr("data-lock_features");
        if (model) {
          // sentry / sentry-privacy -> insert "-ultra" right after "sentry"
          let key = model;
          if (features === "ultra") key = key.replace("sentry", "sentry-ultra");
          warrantyKeys.push(`${key}-gate-lock`);
        }
      }

      let anyAvailable = false;
      ["3", "5"].forEach((years) => {
        const periodItem = periodItems.filter(`[data-ew_years='${years}']`);
        const variantIds = [];
        let total = 0;
        let compareTotal = 0;
        let description = "";
        let complete = warrantyKeys.length > 0;

        warrantyKeys.forEach((key) => {
          const dataRow = $(
            `[data-option='locks-warranty'] .extended-warranty-item[data-lock_model='${key}'][data-lock_ew_years='${years}']`,
          ).first();
          const variantId = dataRow.attr("data-variant");
          const comboItem = variantId ? $(`#${variantId}`) : $();
          const price = comboItem.length ? comboItem.attr("data-price") : null;
          if (variantId && price != null) {
            variantIds.push(variantId);
            total += Number(String(price).replace(/,/g, ""));
            compareTotal += Number(
              String(comboItem.attr("data-compare") || "0").replace(/,/g, ""),
            );
            // First matching lock (door before gate) supplies the description.
            if (!description) description = dataRow.find(".ew-desc").html() || "";
          } else {
            complete = false;
          }
        });

        if (complete && variantIds.length) {
          periodItem
            .attr("data-variants", variantIds.join(","))
            .attr("data-price", total)
            .removeClass("hide");
          periodItem
            .find(".price")
            .text(theme.Currency.formatMoney(total * 100).replace(".00", ""));
          periodItem
            .find(".compare-at-price")
            .text(
              compareTotal > total
                ? theme.Currency.formatMoney(compareTotal * 100).replace(
                    ".00",
                    "",
                  )
                : "",
            );
          periodItem.find(".description").html(description);
          anyAvailable = true;
        }
      });

      if (anyAvailable) warranty_addon.removeClass("hide");
      updateLockWarrantyAddOnPrice();
      adjustAccordion(warranty_addon.filter(".open"));
    }

    function summarizePrices() {
      const productType = $("[data-option='product_type'] .item.active").attr(
        "data-product_type",
      );

      let doorPrice = getDoorPrice();
      let gatePrice = getGatePrice();
      let lockPrice = getLockPrice();
      let lockWarrantyPrice = getLockWarrantyPrice();

      function getDoorPrice() {
        let price = 0;
        price += Number(
          (
            $(
              `#${$("[data-option='door-size'] .item.active").attr("data-variant")}`,
            ).attr("data-price") || "0"
          ).replace(/,/g, ""),
        );

        if (price == 0) return price;

        price += getDoorAddOnPrice();

        return price;
      }

      function getGatePrice() {
        let price = 0;
        price += Number(
          (
            $(
              `#${$("[data-option='gate-design']:not(.hide) select:not(.hide)").val()}`,
            ).attr("data-price") || "0"
          ).replace(/,/g, ""),
        );

        if (price == 0) return price;

        price += getGateAddOnPrice();

        return price;
      }

      function getDoorAddOnPrice() {
        let addOnPrice = 0;
        const addOnOptions = ["door-mortice_lock_set", "door-closer"];
        addOnOptions.forEach((option) => {
          addOnPrice += Number(
            $(
              `#${$(`[data-option='${option}'] .item.active`).attr("data-variant")}`,
            ).attr("data-price") || 0,
          );
        });

        return addOnPrice;
      }

      function getGateAddOnPrice() {
        let addOnPrice = 0;
        const addOnOptions = [
          "gate-mortice_lock_set",
          "gate-plate",
          "gate-unit_number",
        ];
        addOnOptions.forEach((option) => {
          const addOnVariant = $(`[data-option='${option}'] .item.active`).attr(
            "data-variant",
          );
          if (addOnVariant) {
            addOnPrice += Number($(`#${addOnVariant}`).attr("data-price") || 0);
          }
        });

        return addOnPrice;
      }

      let price =
        productType == "bundle"
          ? doorPrice + gatePrice
          : productType == "door"
            ? doorPrice
            : gatePrice;
      let compare = 0;

      $("#ProductPrice-product-template").removeClass("hasFrom");

      if (price == 0) {
        $("#ProductPrice-product-template").addClass("hasFrom");
        price = 499;
      } else {
        price += Number(lockPrice.replace(/,/g, ""));
        price += Number(lockWarrantyPrice.replace(/,/g, ""));
      }

      $("#currentSelection").attr("data-price", price);
      $("#currentSelection").attr("data-compare", compare);

      updatePrice();
      $(".payment-alt-options .price-value.grab-info").text(
        parseInt(price / 4),
      );
      $(".payment-alt-options .price-value.atome-info").text(
        parseInt(price / 3),
      );
    }

    function updateSmartLockAddOnPrice() {
      const price = getLockPrice();
      $(".custom_accordion[data-product_type='locks-addon'] .addon-price").text(
        price,
      );
    }
    updateSmartLockAddOnPrice();

    function getLockPrice() {
      let price = "0";

      const lockType = $("[data-option='locks-type'] .item.active").attr(
        "data-lock_type",
      );
      let variantId = null;
      switch (lockType) {
        case "bundle":
          const doorLock_model = $(
            "[data-option='door-lock-model'] .item.active",
          ).attr("data-lock_model");
          const doorLock_features = $(
            "[data-option='door-lock-features'] .item.active",
          ).attr("data-lock_features");
          const doorLock_colour = $(
            "[data-option='door-lock-colour'] .item.active",
          ).attr("data-lock_colour");
          const gateLock_model = $(
            "[data-option='gate-lock-model'] .item.active",
          ).attr("data-lock_model");
          const gateLock_features = $(
            "[data-option='gate-lock-features'] .item.active",
          ).attr("data-lock_features");
          const gateLock_colour = $(
            "[data-option='gate-lock-colour'] .item.active",
          ).attr("data-lock_colour");
          let bundle_handle = `${doorLock_model}${doorLock_features == "ultra" ? "-ultra" : ""}-door-lock-${doorLock_colour}-${gateLock_model}${gateLock_features == "ultra" ? "-ultra" : ""}-gate-lock-${gateLock_colour}`;
          bundle_handle = bundle_handle.replace(
            "-privacy-ultra-",
            "-ultra-privacy-",
          );
          const lockBundleItem = $(`[data-handle='${bundle_handle}']`);
          variantId = lockBundleItem.attr("data-variant");
          break;
        case "door_lock":
          variantId = $("[data-option='door-lock-colour'] .item.active").attr(
            "data-variant",
          );
          break;
        case "gate_lock":
          variantId = $("[data-option='gate-lock-colour'] .item.active").attr(
            "data-variant",
          );
          break;
      }
      if (variantId) {
        const variant = $(`#${variantId}`);
        if (variant.length) {
          price = variant.attr("data-price");
        }
      }

      return price;
    }

    function updateLockWarrantyAddOnPrice() {
      let price = Number(getLockWarrantyPrice().replace(/,/g, ""));
      $(
        ".custom_accordion[data-product_type='locks-warranty-addon'] .addon-price",
      ).text(price);
    }
    updateLockWarrantyAddOnPrice();

    function getLockWarrantyPrice() {
      const active = $(
        ".door-gate-bundle-selector[data-option='locks-warranty'] .item.active",
      );
      const variantIds = (active.attr("data-variants") || "")
        .split(",")
        .filter(Boolean);
      if (!variantIds.length) return "0";

      let total = 0;
      variantIds.forEach((variantId) => {
        const variant = $(`#${variantId}`);
        if (variant.length) {
          total += Number((variant.attr("data-price") || "0").replace(/,/g, ""));
        }
      });

      return String(total);
    }

    function resetAll() {
      $(".custom_accordion .item.active").removeClass("active");
      $(
        "[data-option='door-fire_rating'], [data-option='door-size'], [data-option='gate-size'], [data-option='gate-design']",
      ).addClass("hide");
      $("[data-option='locks-type'] .item:last-child").click();
    }

    function updateBundleImage() {}

    function updateDoorImage() {
      let url = null;

      const laminate_variantId = $(
        "[data-option='door-laminate'] select",
      ).val();
      const laminate = $(`#${laminate_variantId}`);

      const doorSize = $("[data-option='door-size'] .item.active").attr(
        "data-door_size",
      );
      switch (doorSize) {
        case "3ftx7ft-single-leaf":
          url = laminate.attr("data-door_3x7");
          break;
        case "4ftx7ft-double-leaf":
          url = laminate.attr("data-door_4x7");
          break;
      }
      loadImage_door(url, (loadedUrl) => {
        if (loadedUrl) {
          updateImage_door(loadedUrl);
        }
      });
    }

    function updateGateImage() {
      const design = $(
        "[data-option='gate-design']:not(.hide) select:not(.hide) option:selected",
      ).text();
      const colour =
        $("[data-option='gate-colours'] .item.active")
          .attr("data-title")
          ?.replaceAll(" ", "") || "SatinBlack";

      if (design && colour) {
        loadImage_gate(
          colour == "SatinBlack" ? design : `${design}-${colour}`,
          (loadedUrl) => {
            if (loadedUrl) {
              updateImage_gate(loadedUrl);
            }
          },
        );
      }
    }
    // #endregion

    // Init select2
    (function () {
      // Door laminate
      $("[data-option='door-laminate'] select").select2({
        minimumResultsForSearch: Infinity,
      });
      // Gate design
      $("[data-option='gate-design'] select").select2({
        minimumResultsForSearch: Infinity,
      });
      // Gate laminate
      $("[data-option='gate-laminate'] select").select2({
        minimumResultsForSearch: Infinity,
      });
    })();

    // Add tooltip
    (function () {
      // Door type
      tippy(".tooltip-door-type", {
        content:
          "Solid Wood: Solid Wood Core<br>Fire Rated: Insulated Core<br><br>If your existing door is fire rated, it must be replaced with a fire rated door to comply with SCDF requirements",
        allowHTML: true,
        placement: "bottom",
        theme: "light",
      });
    })();
  })();

  $(window).on("resize", function () {
    adjustAccordion($(".custom_accordion.open"));
  });

  $(".thumb-disclaimer").addClass("hide");
})();
